import { s, type Infer } from '../../format/schema';
import { formatMessageSetting } from '../card';

export const numberStepperSettings = s.strictObject({
  step: s
    .number()
    .refine(step => step > 0, 'should be above 0')
    .optional(),
  integerOnly: s.boolean().optional(),
  ...formatMessageSetting,
});

export type NumberStepperSettings = Infer<typeof numberStepperSettings>;
